import en from './en.json';
import de from './de.json';
import fi from './fi.json';
import fr from './fr.json';
import nl from './nl.json';
import no from './no.json';
import pt from './pt.json';
import sv from './sv.json';

// en.json is the source: every other file is typed against it, so a missing or
// stray key is a compile error rather than a blank spot on the page.
export type Translation = typeof en;

export interface Locale {
    code: string;
    // The language in its own language, because that is what a visitor recognises.
    label: string;
    // Extra codes a browser may report for this language, matched before the dash.
    aliases?: string[];
    translation: Translation;
}

// Adding a language is a data change: drop a JSON next to en.json and add a line.
export const locales: Locale[] = [
    {code: 'en', label: 'English', translation: en},
    {code: 'fr', label: 'Français', translation: fr},
    {code: 'de', label: 'Deutsch', translation: de},
    {code: 'nl', label: 'Nederlands', translation: nl},
    {code: 'pt', label: 'Português', translation: pt},
    {code: 'sv', label: 'Svenska', translation: sv},
    // Bokmål browsers report nb-NO; the file is named for the macrolanguage.
    {code: 'no', label: 'Norsk', aliases: ['nb', 'nn'], translation: no},
    {code: 'fi', label: 'Suomi', translation: fi},
];
